import { Form, Select } from '@maxtropy/components';
import { Col, FormInstance, Row } from 'antd';
import { useEffect, useState } from 'react';
import { apiV2EnergyOverviewMediumByEnergyUnitPost } from '@maxtropy/device-customer-apis-v2';
import BindUnitModal, { AnalysisUnit } from './BindUnitModal';

interface Option {
  label?: number | string;
  value?: number | string;
}

interface EnergyStatisticsRowProps {
  index: number;
  isEdit: boolean;
  placeholder: string;
  unitGroup: AnalysisUnit[];
  form: FormInstance<any>;
  onLoadingChange?: (loading: boolean) => void;
}

const EnergyStatisticsRow = ({
  index,
  isEdit,
  placeholder,
  unitGroup,
  form,
  onLoadingChange,
}: EnergyStatisticsRowProps) => {
  const watchedUnit = Form.useWatch(['energyStatisticsUnits', index, 'unit'], form);
  const [mediumOptions, setMediumOptions] = useState<Option[]>([]);
  useEffect(() => {
    if (!watchedUnit?.energyUnitList.length) {
      setMediumOptions([]);
      return;
    }
    // 根据用能单元获取介质选项
    onLoadingChange?.(true);
    apiV2EnergyOverviewMediumByEnergyUnitPost({
      list: watchedUnit.energyUnitList.map((i: any) => i.energyUnitIds) || [],
    })
      .then(res => {
        setMediumOptions((res.list || []).map(i => ({ label: i.energyName, value: i.id })));
      })
      .catch(() => undefined)
      .finally(() => onLoadingChange?.(false));
  }, [watchedUnit]);

  return (
    <Row gutter={8}>
      <Col span={12}>
        <Form.Item name={[index, 'unit']}>
          <BindUnitModal index={index} isEdit={isEdit} unitGroup={unitGroup} form={form} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name={[index, 'medium']} label="能源介质选择：" style={{ marginLeft: '-90px' }}>
          <Select
            style={{
              width: '472px',
            }}
            disabled={!isEdit}
            placeholder={placeholder}
            options={mediumOptions}
            allowClear
            mode={index === 0 ? undefined : 'multiple'}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EnergyStatisticsRow;
